export default __webpack_public_path__ + "static/media/img_banner_FAQ.3ecd253f.png";